<div class="container-fluid p-0" style="height: 100dvh;">
  <router-outlet></router-outlet>
</div>
